import axiosClient from "../axios-client";

// FILE IMPORTS
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";

// REDUX IMPORTS
import { getAdminSuccess, getApprovedAstrologersSuccess, getNotificationsSuccess } from "../reducers/adminReducer";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const adminsListGet = async (dispatch) => {
    return axiosClient
        .get("/admin/admin-list")
        .then((res) => {
            dispatch(getAdminSuccess(res.data));
            // Return the rows as well as storing them, so a caller can use the
            // response directly instead of reading the store back on the next render.
            return res?.data || [];
        })
        .catch((error) => {
            toastMessage("Admin records not found", "error");
            // Rethrow so a failure surfaces as an error state rather than an empty list.
            throw error;
        });
};


export const userListGet = async (dispatch, role) => {
    return axiosClient
        .get(`/admin/user-list/${role}`)
        .then((res) => {
            dispatch(getAdminSuccess(res.data));
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Admin records not found", "error");
            throw error;
        });
};


export const updateNotification = async (notification_id) => {
    return axiosClient
        .get(`/admin/update-notification/${notification_id}`)
        .then((res) => { })
        .catch((error) => {
            console.log(error);
            toastMessage("Notifications not updated", "error");
            throw error;
        });
};


export const approvedAstrologerList = async (dispatch) => {
    return axiosClient
        .get("/admin/approved-astrologers")
        .then((res) => {
            dispatch(getApprovedAstrologersSuccess(res?.data || []));
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Approved astrologers list not found", "error");
            throw error;
        });
};


export const getPromotionalNotification = async (dispatch) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/admin/promotional-notifications`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            console.log(error);
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== POST API ==================================
// ===============================================================================

export const agentNotifications = async (dispatch, data) => {
    return axiosClient
        .post(`/admin/notifications`, data)
        .then((res) => {
            dispatch(getNotificationsSuccess(res?.data || []));
            return res?.data;
        })
        .catch((error) => {
            console.log(error);
            toastMessage("Notifications not found", "error");
            throw error;
        });
};


export const sendPromotionalNotification = async (data) => {
    return axiosClient
        .post(`/admin/promotional-notifications`, data)
        .then((res) => {
            toastMessage("Promotional notifications queued and processing started.", "success");
            return res?.data
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
};


// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================

export const updateIsEnbaleStatus = async (id, data) => {
    return axiosClient
        .put(`/admin/enable/${id}`, data)
        .then((res) => res?.data)
        .catch((error) => {
            console.log(error);
            toastMessage("Enable/Disable status not updated", "error");
            throw error;
        });
};


export const updateUserRoles = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/admin/update-role/${id}`, data)
        .then((res) => {
            toastMessage("User role updated successfully", "success");
        })
        .catch((error) => {
            console.log(error);
            toastMessage("User role not updated", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== DELETE API ===================================
// ===============================================================================

export const deleteAdminUser = async (id, dispatch) => {
    return axiosClient
        .delete(`/admin/user/${id}`)
        .then((res) => {
            toastMessage("Admin deleted successfully", "success");
            return res?.data;
        })
        .catch((error) => {
            // The API explains refusals (not a super admin, self-delete, IDAM failure);
            // show that rather than a generic message.
            toastMessage(error?.response?.data?.error || "Admin not deleted", "error");
            throw error;
        });
};